






































import { ContractBlockVue } from "fs-pb-vue2/vueModels/contracts-panel/ContractBlockVue";
import { Component } from "vue-property-decorator";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";

@Component({})
export default class ContractBlock extends ContractBlockVue {
    getContractIconClass(contract: ContractModel): string {
      if (contract.Data.ContractType === 1) return "deposit-icon";
      else if (contract.Data.ContractType === 2) return "time-icon";
    }
}
